import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment/moment';
import { delay, Observable, of } from 'rxjs';
import { Ticket, TicketPriority, TicketState, TicketType } from '../models/ticket.model';
import { tickets } from './tickets-demo.data';

const addLog: (process: 'READ' | 'UPDATE' | 'CREATE', description: string) => string = (process, description) => {
  return `Data was update during ${process} process at ${moment(new Date()).format('MMM DD, YYYY, h:mm:ss A')}\r\n\r\n${description}`;
};

@Injectable()
export class TicketsDemoInterceptor implements HttpInterceptor {
  private router = inject(Router);

  private tickets = tickets;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentUrl = this.router.url;

    if (!currentUrl.startsWith('/AP/TicketsDemo')) {
      return next.handle(req);
    }

    if (req.url === '/api/tickets') {
      return of(
        new HttpResponse({
          status: 200,
          body: {
            data: this.tickets,
            summary: {
              total: this.tickets.length,
              opened: this.tickets.filter((item) => item.state === TicketState.Opened).length,
              resolved: this.tickets.filter((item) => item.state === TicketState.Closed).length
            }
          }
        })
      ).pipe(delay(1000));
    }

    if (req.url === '/api/ticket') {
      const ticket = this.tickets.find((item) => item.id === (req.body as { id: string }).id);

      ticket.description = addLog('READ', ticket.description);

      return of(new HttpResponse({ status: 200, body: ticket })).pipe(delay(1000));
    }

    if (req.url === '/api/ticket/update') {
      const ticket = (req.body as { ticket: Ticket }).ticket;
      const idx = this.tickets.findIndex((item) => item.id === ticket.id);

      ticket.description = addLog('UPDATE', ticket.description);
      this.tickets[idx] = ticket;

      return of(new HttpResponse({ status: 200, body: true })).pipe(delay(1000));
    }

    if (req.url === '/api/ticket/create') {
      const description = addLog('CREATE', (req.body as { description: string }).description);

      this.tickets.unshift({
        id: String(new Date().getTime()),
        type: TicketType.Change,
        priority: TicketPriority.Medium,
        assetId: '',
        asset: {
          name: 'Comp - NNN'
        },
        companyId: '',
        companyName: 'Foo',
        state: TicketState.Opened,
        summary: { conversations: { total: 0 } },
        title: 'current_user_777@gmail.com',
        description: description,
        created: {
          email: 'current_user_777@gmail.com',
          id: '0000',
          firstName: 'current',
          lastName: 'user',
          date: new Date()
        }
      });

      return of(new HttpResponse({ status: 200, body: true })).pipe(delay(1000));
    }

    if (req.url === '/api/ticket/delete') {
      this.tickets = this.tickets.filter((ticket) => ticket.id !== (req.body as { id: string }).id);

      return of(new HttpResponse({ status: 200, body: true })).pipe(delay(3000));
    }

    if (req.url === '/api/ticket/resolve') {
      const ticket = this.tickets.find((item) => item.id === (req.body as { id: string }).id);

      ticket.state = TicketState.Closed;

      return of(new HttpResponse({ status: 200, body: true })).pipe(delay(3000));
    }

    return next.handle(req);
  }
}
